import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dea9a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phone-submit" }

import { computed, onMounted, reactive, Ref, ref } from 'vue'
import { modifyPassword } from '@/api/user'
import { ERR_SUCCESS } from '@/api/config'
import { ElMessage } from 'element-plus/lib'
import { UserInfo } from '@/types'
import store from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'password',
  props: ['hideDialog'],
  setup(__props) {

const formRef: Ref<null | { validate: () => Promise<boolean>; clearValidate: () => void }> = ref(null)

// eslint-disable-next-line no-undef
const props = __props
const form = reactive({
  oldPass: '',
  newPass: '',
  confirmPass: ''
})

function validateConfirmPass (rule: any, value: string, callback: (arg0: Error | undefined) => void) {
  if (value !== form.newPass) {
    callback(new Error('两次输入密码不一致'))
  } else {
    callback(undefined)
  }
}

const rules = {
  oldPass: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
  newPass: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
  ],
  confirmPass: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    { validator: validateConfirmPass, trigger: 'blur' }
  ]
}

const userInfo = computed<UserInfo>(() => {
  return store.getters.userInfo
})

onMounted(() => formRef.value?.clearValidate())
async function handleSubmit () {
  try {
    await formRef.value?.validate()
    const params = { id: userInfo.value.id, oldPass: form.oldPass, password: form.newPass }
    const { code, message } = await modifyPassword(params)
    if (code === ERR_SUCCESS) {
      ElMessage.success(message + '，请用新密码登录。')
      props.hideDialog()
      setTimeout(async () => {
        await store.dispatch('user/logout')
      }, 3000)
    } else {
      ElMessage.error(message)
    }
  } catch (error) {
    ElMessage.error('请正确填写相关字段信息!')
  }
}

function cancel () {
  props.hideDialog()
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: form,
    rules: rules,
    ref_key: "formRef",
    ref: formRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "原始密码",
        prop: "oldPass"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: form.oldPass,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.oldPass) = $event)),
            placeholder: "请输入原始密码",
            "show-password": "",
            clearable: "",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "新设密码",
        prop: "newPass"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: form.newPass,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.newPass) = $event)),
            placeholder: "请输入新密码",
            "show-password": "",
            clearable: "",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "确认密码",
        prop: "confirmPass"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: form.confirmPass,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.confirmPass) = $event)),
            placeholder: "请再次输入新密码",
            "show-password": "",
            clearable: "",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _withModifiers(handleSubmit, ["stop"])
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})